import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { type TrackSelectionTrigger, useTrackSelectedItems } from '@air/analytics';
import { shiftSelectHighlightedItemsSelector } from '@air/redux-selected-items';

import { calculateRankForSingleSelection } from '~/analytics/rankUtils';
import { getTrackSelectedItemsCountsAndType } from '~/analytics/utils';
import { selectShiftSelectedHighlightedGalleryItemsAction } from '~/store/selectedItems/actions';
import { type SelectableGalleryItem } from '~/store/selectedItems/types';
import { useAirStore } from '~/utils/ReduxUtils';

export function useSelectShiftSelectedHighlightedItems() {
  const dispatch = useDispatch();
  const store = useAirStore();
  const { trackSelectedItems } = useTrackSelectedItems();

  const selectShiftSelectedHighlightedItems = useCallback(
    (nextAnchor: SelectableGalleryItem, trigger: TrackSelectionTrigger) => {
      const nextSelections = shiftSelectHighlightedItemsSelector(store.getState());
      const trackingParams = getTrackSelectedItemsCountsAndType(nextSelections);
      const rank = calculateRankForSingleSelection(store, nextSelections);

      trackSelectedItems({
        ...trackingParams,
        trigger,
        ...(rank !== undefined && { rank }),
      });

      dispatch(selectShiftSelectedHighlightedGalleryItemsAction({ nextAnchor }));
    },
    [dispatch, store, trackSelectedItems],
  );

  return { selectShiftSelectedHighlightedItems };
}
